/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ReportHeader_reports = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportHeader_reports",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CopyWidgetsDialog_reports",
      "args": null
    }
  ],
  "type": "ReportConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/__generated__/ReportHeader_reports.graphql.js